//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.BaseSymbolBuilder.js";
let d=[[],[[["index","defaultValue"],"AddExtension",{},2,0],[["index"],"RemoveExtension",{},1,0],[["start","end"],"AddEndExtensions",{},2,0],[[],"RemoveEndExtensions",{},0,0],[["index","value1","value2"],"SetIndividualExtensions",{},3,0],[["start","end"],"SetEndExtensions",{},2,0],[["nCount"],"GetEndExtensions",{R_:{extensionValues:""}},0,0],[["nCount"],"GetAllIndividualExtensions",{R_:{extensionValues:""}},0,0],[["extensionValues"],"SetAllIndividualExtensions",{},1,0],[["nCount"],"GetAllExtensions",{R_:{extensionValues:""}},0,0],[["defaultValue"],"ResetAllExtensions",{},1,0]],[]];
SPLM.Annotations.CenterlineBuilder = class extends SPLM.Annotations.BaseSymbolBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.CenterlineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;